import {
    HSStaticMethods,
} from 'flyonui/flyonui';

export function reinitializePlugins() {
    setTimeout(() => {
        if (HSStaticMethods && typeof HSStaticMethods.autoInit === 'function') {
            HSStaticMethods.autoInit(); // Инициализация всех плагинов FlyonUI
        } else {
            console.warn('HSStaticMethods.autoInit is not available.');
        }
    }, 400);
}